// source of truth for device models - https://git.taservs.net/ecom/service-common/blob/master/service-common/src/main/scala/com/evidence/service/common/data/device/Model.scala#L39
export enum AxonDeviceModels {
  // DSA Models
  AxonBody3 = 'AXON_BODY_3',
  AxonBody4 = 'AXON_BODY_4',
  AxonBodyWorkforce = 'AXON_BODY_WORKFORCE',
  AxonBodyWorkforceMini = 'AXON_BODY_WORKFORCE_MINI',
  AxonFleet3Hub = 'AXON_FLEET_3_HUB',
  AxonFleet3DualViewCamera = 'AXON_FLEET_3_DUAL_VIEW_CAMERA',
  AxonFleet3InteriorCamera = 'AXON_FLEET_3_INTERIOR_CAMERA',
  AxonFleet3ExteriorCamera = 'AXON_FLEET_3_EXTERIOR_CAMERA',
  AxonAir = 'AXON_AIR',
  AxonOutpost = 'AXON_OUTPOST',
  AxonLightpost = 'AXON_LIGHTPOST',
  Unspecified = 'UNSPECIFIED',
}
